import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=1b761c38&scoped=true&lang=pug"
import script from "./Tooltip.vue?vue&type=script&lang=ts"
export * from "./Tooltip.vue?vue&type=script&lang=ts"
import style0 from "./Tooltip.vue?vue&type=style&index=0&id=1b761c38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b761c38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
